import { toBooleanValue } from "./optionNormalizers";

const normalizeArray = (value) => (Array.isArray(value) ? value.filter(Boolean) : []);

const normalizeText = (value) => {
  if (value === null || typeof value === "undefined") {
    return undefined;
  }

  const trimmed = String(value).trim();
  return trimmed === "" ? undefined : trimmed;
};

export const buildEncounterCheckInV2Payload = (source = {}, checkInDateTime) => {
  const payload = {};

  const normalizedCheckInDateTime = normalizeText(checkInDateTime);
  if (normalizedCheckInDateTime) {
    payload.checkInDateTime = normalizedCheckInDateTime;
  }

  const medicalHistory = normalizeArray(source.medicalHistory);
  if (medicalHistory.length > 0) {
    payload.medicalHistory = medicalHistory;
  }

  const medicalHistoryOther = normalizeText(source.medicalHistoryOther);
  if (medicalHistoryOther) {
    payload.medicalHistoryOther = medicalHistoryOther;
  }

  const familyHistory = normalizeArray(source.familyHistory);
  if (familyHistory.length > 0) {
    payload.familyHistory = familyHistory;
  }

  const familyHistoryOther = normalizeText(source.familyHistoryOther);
  if (familyHistoryOther) {
    payload.familyHistoryOther = familyHistoryOther;
  }

  const smoking = toBooleanValue(source.smoking);
  if (smoking !== null) {
    payload.smoking = smoking;
  }

  const yearsSmoking = normalizeText(source.yearsSmoking);
  if (yearsSmoking) {
    payload.yearsSmoking = yearsSmoking;
  }

  const drinking = toBooleanValue(source.drinking);
  if (drinking !== null) {
    payload.drinking = drinking;
  }

  const drinksPerWeek = normalizeText(source.drinksPerWeek);
  if (drinksPerWeek) {
    payload.drinksPerWeek = drinksPerWeek;
  }

  const exercise = toBooleanValue(source.exercise);
  if (exercise !== null) {
    payload.exercise = exercise;
  }

  return payload;
};
